import { Component } from '@angular/core';
import { SetupComponent } from './setup/setup.component';
import { StandoffCalculatorComponent } from './standoff-calculator/standoff-calculator.component';
import { HierarchyComponent } from './hierarchy/hierarchy.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-rheological-hierarchy',
  standalone: true,
  imports: [CommonModule, SetupComponent, StandoffCalculatorComponent, HierarchyComponent],
  templateUrl: './rheological-hierarchy.component.html',
  styleUrls: ['./rheological-hierarchy.component.css']
})
export class RheologicalHierarchyComponent {
  activeTab: string = 'setup';

  constructor() {}

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }
}
